import { Injectable } from '@angular/core';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';
import { MonographSalesCatalogue } from '../../models/monograph/monograph-sales-catalogue.model';
import { MonographValidationResponse } from '../../models/monograph/monograph-validation-response.model';

@Injectable({
    providedIn: 'root'
})
export class MonoGraphPackagePlanningLineRule {

    constructor(private monoGraphSC: MonographSalesCatalogue) { }

    validateMonoGraphPackage(packageCode: string, monographCode: string, compendiumCode: string): CommercialItemValidationResponse {
        const monograph = this.monoGraphSC.monographs
            .filter(c => c.code === monographCode && c.compendium?.code === compendiumCode).shift();
        const packageItem = monograph?.monographItems.find(c => c.salesCatalogueItem.code === packageCode)?.salesCatalogueItem;
        const monoGraphPackage: MonographValidationResponse = {};
        if (packageItem) {
            monoGraphPackage.packageCode = packageItem.code;
            monoGraphPackage.name = packageItem.name;
            monoGraphPackage.compendiumName = monograph.compendium?.name;
            monoGraphPackage.monographName = monograph.name;
            monoGraphPackage.compendiumCode = monograph.compendium?.code;
            monoGraphPackage.monographCode = monograph.code;
            monoGraphPackage.price = packageItem.price;
            monoGraphPackage.salesCatalogCode = this.monoGraphSC.code;
        }
        return {
            data: monoGraphPackage,
            isValid: packageItem !== undefined,
        };
    }
}
